export class DipDipendente {
    dipId: number;
    dipNome: string;
    dipCognome: string;
    dipCostoOrario: number;
    dipDiaria: number;
}